// extracted by mini-css-extract-plugin
export default {"root":"xH8ioIlz","logoLine":"f-3ja+1+","title":"oS4lRQb6","subtitle":"NlB3FoXM","logo":"gsHA6cXo"};